
export const InDevelopment = () => {
   
    return (
        <label>Раздел находится в разработке</label>        
    );    
};

